import * as React from 'react';
import { connect } from 'react-redux';
import { Trans } from 'react-i18next';
import { select } from '@rematch/select';

import { AppLayout } from '../../layouts/AppLayout';
import { dispatch } from '../../store';
import { Loader } from '../../atoms/loader';
import { ListItem } from './ListItem';
import { Box } from '../../atoms/box';
import { Icon } from '../../atoms/icon';
import { OrganizationModalDeprecated } from '../../atoms/organization-modal';
import { Text } from '../../atoms/text';
import { Button } from '../../atoms/button';
import { ThemeConsumer } from '../../atoms/theme';
import { CommunityService } from '../../services/CommunityService';
import { can } from '../../utils/permissions';
import { message } from 'ui';

export class Renderer extends React.Component {
  state = {
    isOrganizationPreviewModalOpen: false,
    selectedCommunityForPreview: null,
    selectedOrganizationForPreview: null,
    selectedCategories: [],
    showCategoryOrganizations: false,
    categoryOrganizations: [],
    loadingOrganizationJoinId: '',
    selectedOrganization: null,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    if (!this.props.category) {
      await this.props.loadCategory();
    }

    await this.props.loadOrganizations();
  };

  renderCategoryName = (theme) => {
    if (this.props.category) {
      return (
        <Box>
          <Text size={28} weight="600" color={theme.color.brand}>
            {this.props.category.name}
          </Text>
        </Box>
      );
    }

    return <Loader />;
  };

  renderListCategoryOrganizations = () => {
    return (
      <React.Fragment>
        <Box>
          <Text color="#A2ABBB" size={17} style={{ marginBottom: 10, marginTop: 40 }}>
            <Trans>Find Organizations</Trans>
          </Text>
        </Box>
        {this.props.organizationsByCategories.length > 0 ? (
          <div className="row category-organizations__list">
            {this.props.organizationsByCategories.map((organization) => (
              <div key={organization.id} className="col-xs-12 category-organizations__item">
                <ListItem
                  onClick={() => this.onOpenOrganizationPreviewModal(organization)}
                  organization={organization}
                  onJoinNow={() => this.onOrganizationJoinNow(organization)}
                  onRequestToJoin={() => this.onOrganizationRequestToJoin(organization)}
                  joining={this.state.loadingOrganizationJoinId === organization.id}
                />
              </div>
            ))}
          </div>
        ) : this.props.loadingCategoryOrganizations ? (
          <Loader />
        ) : (
          <div style={{ textAlign: 'centre' }}>
            <Text>
              <Trans>No Organizations</Trans>
            </Text>
          </div>
        )}
      </React.Fragment>
    );
  };

  onOrganizationJoinNow = async (organization, fetchData) => {
    this.setState({ loadingOrganizationJoinId: organization.id });
    await dispatch.organizations.joinAsync(organization.id);

    await fetchData?.();

    this.setState({ selectedOrganizationForPreview: organization });
    message.success(`You've joined the {{ name }} organization`, undefined, undefined, { name: organization.name})

    this.setState({ loadingOrganizationJoinId: '' });
  };

  onCommunityJoinNow = async (community, params) => {
    await CommunityService.join(community.id, params);

    await dispatch.session.fetchUser();
  };

  onOpenOrganizationPreviewModal = (organization) => {
    this.setState({
      isOrganizationPreviewModalOpen: true,
      selectedOrganizationForPreview: organization,
    });
  };

  onOrganizationRequestToJoin = async (organization) => {};

  onOrganizationExploring = async (organization) => {
    window.location.href = `/organizations/${organization.id}`;
  };

  onCommunitiesExploring = async (community) => {
    window.location.href = `/communities/${community.id}`;
  };

  onRequestClose = () => {
    this.setState({
      selectedCommunityForPreview: null,
      isOrganizationPreviewModalOpen: false,
      selectedOrganizationForPreview: null,
    });
  };

  onCommunityClick = (community) => {
    if (can(community, 'Community', 'joined')) {
      return false;
    }

    this.setState({
      selectedCommunityForPreview: community,
    });

    return true;
  };

  render() {
    return (
      <AppLayout
        center={
          <ThemeConsumer>
            {(theme) => (
              <React.Fragment>
                <div>
                  <Button
                    color="#E8EBEE"
                    textColor="#A2ABBB"
                    size="sm"
                    type="button"
                    block
                    onClick={() => {
                      this.props.history.push('/network/explore');
                    }}
                    title={({ textColor }) => (
                      <React.Fragment>
                        <Icon name="pba-arrow-left" size={25} color={textColor} />{' '}
                        <Text className="category-back-button__text">
                          <Trans>Back</Trans>
                        </Text>
                      </React.Fragment>
                    )}
                    className="category-back-button"
                  />
                </div>
                {this.renderCategoryName(theme)}
                <div className="category-organizations">
                  <OrganizationModalDeprecated
                    isOpen={!!this.state.isOrganizationPreviewModalOpen}
                    onRequestClose={this.onRequestClose}
                    onRequestToJoin={() => {}}
                    onJoinNow={
                      this.state.selectedCommunityForPreview ? this.onCommunityJoinNow : this.onOrganizationJoinNow
                    }
                    type={this.state.selectedCommunityForPreview ? 'community' : 'organization'}
                    data={this.state.selectedCommunityForPreview || this.state.selectedOrganizationForPreview}
                    onExploring={
                      this.state.selectedCommunityForPreview
                        ? this.onCommunitiesExploring
                        : this.onOrganizationExploring
                    }
                    onCommunityClick={this.onCommunityClick}
                  />

                  {this.props.loading ? <Loader color={theme.color.lightGray} size={30} /> : null}
                  {this.renderListCategoryOrganizations()}
                </div>
              </React.Fragment>
            )}
          </ThemeConsumer>
        }
      />
    );
  }
}

const mapState = (state, props) => {
  return {
    loadingCategoryOrganizations: state.loading.effects.organizations.getByCategory,
    organizationsByCategories: select.organizations.getByCategory(state, {
      category_id: props.match.params.categoryId,
    }),
    category: select.categories.find(state, props.match.params.categoryId),
  };
};

const mapDispatch = (dispatch, props) => {
  return {
    loadCategory: () => {
      return dispatch.categories.find(props.match.params.categoryId);
    },
    loadOrganizations: () => {
      return dispatch.organizations.getByCategory({ category_id: props.match.params.categoryId });
    },
  };
};

export const PageNetworkCategory = connect(mapState, mapDispatch)(Renderer);
